
// Others
import {Component, Vue} from 'vue-property-decorator';
import ClienteService from "@/service/cliente.service";
// Models
import ClienteModel from "@/models/cliente/cliente.model";
import EnderecoModel from "@/models/cliente/endereco.model";
// Components
import DadosClienteComponent from "@/components/DadosClienteComponent.vue";
import EnderecoComponent from "@/components/EnderecoComponent.vue";
import ContatoComponent from "@/components/ContatoComponent.vue";
import AcompanhamentoComponent from "@/components/AcompanhamentoComponent.vue";
import FormatUtil from "@/util/format.util";
import {namespace} from "vuex-class";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";

const loading = namespace('loading');

@Component({
  name: "ClienteViewComponent",
  components: {
    DadosClienteComponent,
    ContatoComponent,
    EnderecoComponent,
    AcompanhamentoComponent
  }
})
export default class ClienteViewComponent extends Vue {

  @loading.Action(MapActionsLoading.OPEN_LOADING) openLoading;
  @loading.Action(MapActionsLoading.CLOSE_LOADING) closeLoading;

  private step = 1;
  private cliente = new ClienteModel();
  private endereco = new EnderecoModel();
  private possuiEndereco: boolean | null = false;
  private possuiContato: boolean | null = false;

  async mounted() {
    const idCliente = this.$route.params.id;
    if (idCliente) {
      this.openLoading();
      this.cliente = await ClienteService.get(idCliente);
      if (this.cliente) {
        this.cliente.cpf_cnpj = FormatUtil.cpfCnpj(this.cliente.cpf_cnpj);
        this.possuiContato = this.cliente.contatos && this.cliente.contatos.length > 0;
        if (this.cliente.endereco && this.cliente.endereco.length > 0) {
          this.endereco = this.cliente.endereco[0];
          this.possuiEndereco = true;
        } else {
          this.possuiEndereco = false;
        }
      }
      this.closeLoading();
    }
  }

}
